<template>
  <div class="col-sm-12 mt-1 nopads list-container">
    <Transition name="fade">
      <!-- Main table element -->
      <div v-if="results.length > 0" class="col-sm-12 list-content result-table">
          <vue3-datatable
              :rows="results"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="70vh"
              :sortable="true"
              skin="bh-table-compact"
              :row-class="getRowClass"
              cell-class="routa-table-cell"
              @row-click="emitDetails"
          >
              <template #created="row">
                  {{ toLocalTime(row.value.created) }}
              </template>
              <template #fixed="row">
                  {{ row.value.fixed ? toLocalTime(row.value.fixed) : '' }}
              </template>
              <template #status="row">
                  {{ this.getDefectStatusString(row.value.status) }}
              </template>
          </vue3-datatable>
       </div>
    </Transition>
  </div>
</template>

<script>
import {timeUtils} from '../../mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'VehicleDefectList',
    mixins: [timeUtils],
    components: {Vue3Datatable},
    props: {
        items: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            sortBy: 'vehicle.lisence_plate',
            sortDesc: true,
            sortDirection: 'asc',
            fields: [
                {field: 'created', title: this.$t('defects.created'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'license_plate', title: this.$t('vehicle_defects.license_plate'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'vehicle', title: this.$t('vehicle_defects.vehicle'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'reporter', title: this.$t('defects.reporter'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'inspectable', title: this.$t('vehicle_defects.inspectable'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'description', title: this.$t('defects.description'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'status', title: this.$t('defects.status'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'fixed', title: this.$t('defects.fixed'),  sort: true, headerClass: 'routa-table-header'},
                {field: 'fixed_by', title: this.$t('defects.fixed_by'),  sort: true, headerClass: 'routa-table-header'},
            ],
            results: []
        }
    },
    watch: {
        items: function () {
            this.initTableItems()
        }
    },
    methods: {
        getRowClass(row) {
            switch (row.status) {
                case 2: return 'routa-table-row selected-row'
                case 3: return 'routa-table-row warning-row'
                case 4: return 'routa-table-row danger-row'
            }
            return 'routa-table-row'
        },

        initTableItems: function () {
            this.results = []
            this.items.forEach(item => {
                this.results.push({
                    id: item.id,
                    license_plate: item.vehicle.license_plate,
                    vehicle: this.getVehicleString(item.vehicle),
                    reporter: item.reporter.last_name + ', ' + item.reporter.first_name,
                    created: item.created_date,
                    description: item.description,
                    inspectable: item.inspectable_name,
                    status: item.status,
                    fixed: item.fixed_date,
                    fixed_by: item.fixer ? item.fixer.last_name + ', ' + item.fixer.first_name : '',
                })
            })
        },
        emitDetails: function (result) {
            // Find defect item from original items and emit request to edit
            let p = this.items.find(item => item.id === result.id)
            if (p) {
                this.$emit('edit', p)
            }
        },
        getDefectRowVariant: function (status) {
            switch (status) {
                case 3:
                    return 'warning'
                case 4:
                    return 'danger'
            }
            return ''
        },
        getDefectStatusString: function (status) {
            switch (status) {
                case 2:
                    return this.$t('inspection.options.okay')
                case 3:
                    return this.$t('inspection.options.defects')
                case 4:
                    return this.$t('inspection.options.ban')
            }
            return '-'
        },
        getVehicleString: function (vehicle) {
            let result = '-'
            if (vehicle && vehicle.make) {
                result = vehicle.make
                if (vehicle.vehicle_model) {
                    result += ' ' + vehicle.vehicle_model
                }
            }
            return result
        }
    }
}
</script>

<style scoped>

</style>
